import Model from './Model';

export default class DownloadCategory extends Model {
  resource() {
    return 'download-categories';
  }
}
